import { VApp } from 'vuetify/lib/components/VApp';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VApp,
    [
      _c(_setup.CoreCookieBanner),
      _vm._v(" "),
      _c(_setup.CoreHeader),
      _vm._v(" "),
      _setup.isDesktop ? _c(_setup.CoreSearch) : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _c(_setup.CoreFooter, { staticClass: "mt-auto" }),
      _vm._v(" "),
      _c(_setup.CoreLineStage),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }